module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "grey lighten-4",
    class: {
      'height': _vm.$vuetify.breakpoint.lgAndUp
    },
    attrs: {
      "right": "",
      "app": "",
      "fixed": "",
      "clipped": "",
      "floating": "",
      "disable-route-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "d-flex": "",
      "align-center": ""
    }
  }, [_vm._v("\n            {Player Type}\n        ")]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "color": "grey",
      "id": "btn-toggle"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('v-icon', [_vm._v("keyboard_arrow_up")]) : _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    class: {
      'hidden': !_vm.show
    },
    attrs: {
      "id": "external-player"
    }
  }, [_c('div', {
    attrs: {
      "id": "youtube-player"
    }
  })]), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('h4', [_vm._v("List Title")])]), _vm._v(" "), _vm._l((_vm.tracks), function(track, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-action', [_vm._v("\n                " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(track) + "\n                ")])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f83f4d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheRightSidebar/TheRightSidebar.vue
// module id = 381
// module chunks = 0